import React from "react";

const Error = ({ header, message }) => {
  return (
    <div className="error">
      <h2>{header}</h2>
      <p>{message}</p>
    </div>
  );
};

export default Error;
